import getStoreProperty from "components/ProjectNonSpecificComponents/DevTools/Functions/getStoreProperty"
import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import Input from "components/ProjectNonSpecificComponents/Elements/Input"
import Whitespace from "components/ProjectNonSpecificComponents/Elements/Whitespace"
import { rmChars } from "components/ProjectNonSpecificComponents/Functions/rmChars"
import { usePTKMStore } from "components/ProjectSpecificComponents/Contexts/PTKMStoreContext"
import InfoBubble from "components/ProjectSpecificComponents/Elements/Global/atoms/InfoBubble"
import { TPickList } from "components/ProjectSpecificComponents/Interfaces/DataInterface"
import { observer } from "mobx-react-lite"
import React, { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { PTKM_REQ_CLASSNAME } from "./ActivatePTKMForm"

interface Props {
	frstPriority: any
	scntPriority: any
	headingLabel?: string
	headingValue?: string
}

const DeadlineFormRLAKRColumn = observer(
	({ frstPriority = [], scntPriority = [], headingLabel, headingValue }: Props) => {
		const { t } = useTranslation()
		const ptkmStore = usePTKMStore()
		const twoDimensional: boolean = useMemo(() => scntPriority && scntPriority.lenth > 0, [])
		const { rlaKrHours } = ptkmStore.ptkmConfig.deadlines.priorityField

		const editRlaKrValues = (type: "rlaHours" | "krHours", key: string, value: string) => {
			var valueType: string = headingValue ?? "singleDimension"
			ptkmStore.editDeadlineHours(valueType, type, key, value)
		}

		const getFieldValue = (type: "rlaHours" | "krHours", value: string): string => {
			const has = Object.prototype.hasOwnProperty

			const cellColumnGroup = headingValue
				? rlaKrHours[headingValue] ?? {}
				: rlaKrHours?.singleDimension ?? {}

			if (has.call(cellColumnGroup, type)) {
				const cellType = cellColumnGroup[type] ?? {}
				if (has.call(cellType, value)) {
					const cellValue = cellType[value]
					return cellValue
				}
			}

			return ""
		}

		return (
			<div id="rla-kr-inputs" className="w-64 mr-8">
				{headingLabel && <p className="w-full text-center font-bold pb-2 h-8">{headingLabel}</p>}

				<HyperDiv direction="row" centeredY>
					<div className="flex flex-row">
						<p className="pr-2">{`${t("rawText.rla")}*`}</p>
						<div>
							<InfoBubble tooltipText={`${t("rawText.rla-desc")}`} />
						</div>
					</div>
					<Whitespace x="2" h />
					<div className="flex flex-row">
						<p className="pr-2">{t("rawText.kr")}</p>
						<div>
							<InfoBubble tooltipText={`${t("rawText.kr-desc")}`} />
						</div>
					</div>
				</HyperDiv>

				<Whitespace x=".8" />

				{frstPriority?.map(({ label, value }: TPickList, index: number) => {
					return (
						<HyperDiv direction="row" centeredY key={label + index} width="100%" padding="2px 0px">
							<Input
								style={{ width: "50%", marginRight: "5%", minWidth: 80 }}
								type="number"
								value={getFieldValue("rlaHours", value)}
								onChange={(e) =>
									editRlaKrValues("rlaHours", String(value), rmChars(e.target.value))
								}
								className={PTKM_REQ_CLASSNAME}
							/>

							<Input
								style={{ width: "50%", minWidth: 80 }}
								type="number"
								value={getFieldValue("krHours", value)}
								onChange={(e) => editRlaKrValues("krHours", String(value), rmChars(e.target.value))}
								className={PTKM_REQ_CLASSNAME}
							/>
						</HyperDiv>
					)
				})}
			</div>
		)
	}
)

export default DeadlineFormRLAKRColumn
